"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class DisclosureButton extends HTMLButtonElement {
    constructor() {
        super();
        this.handleClick = this.handleClick.bind(this);
    }
    connectedCallback() {
        this.addEventListener('click', this.handleClick);
    }
    handleClick() {
        var _a;
        const element = document.getElementById(this.value);
        if (element === null) {
            throw new Error(`Element ${this.value} is not defined`);
        }
        element.hidden = false;
        (_a = this.parentNode) === null || _a === void 0 ? void 0 : _a.removeChild(this);
    }
}
exports.default = DisclosureButton;
